import React from 'react';
import OrganizationIcon from '../../../../core/gd-components/icons/organization/organization-icon'

import Classes from "classnames";

type Props = {
    companyId   : ID
    curMenuId   : string | null
    extensions  : any[]
    sectionName : string | null
    showIcon    : boolean
}

export default class TopCompany extends React.Component<Props> {

    renderExtentions = () => {
        if (this.props.extensions) {
            const renderFunction = this.props.extensions[1];
            return (
                <div className="extensions">
                    {renderFunction()}
                </div>
            )
        }
    };

    render() {
        const company = gd.session.companies.get(this.props.companyId);

        return (
            <div className="ui-top">
                <div className={Classes("company-header", {'has-logo': this.props.showIcon})}>
                    <div className="name-block">
                        {this.props.showIcon &&
                        <div className="logo">
                            <OrganizationIcon organization={company} size="small" />
                        </div>}

                        <div className="name">{company.name}</div>
                        <div className="section">{this.props.sectionName}</div>
                    </div>
                </div>

                {this.renderExtentions()}
            </div>
        );
    }
}